import { TabPill } from 'types/tabs';

const ExpenseTrackerConstants = {};

export enum ExpenseStatus {
  APPROVED = 'APPROVED',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

const rejectReasons = [
  {
    id: 'not_valid',
    label: 'Not valid',
    value: 'not_valid'
  },
  {
    id: 'duplicate',
    label: 'Duplicate',
    value: 'duplicate'
  },
  {
    id: 'other',
    label: 'Other',
    value: 'other'
  }
];

const expenseTrackerColumns = [
  { Header: 'Title', accessor: 'title', width: '20%' },
  { Header: 'Category', accessor: 'categoryName', width: '25%' },
  { Header: 'Branch', accessor: 'branchName', width: '25%' },
  { Header: 'Amount', accessor: 'formattedAmount', width: '10%' },
  { Header: 'Expense Date', accessor: 'expenseDate', width: '10%' },
  { Header: 'Action', accessor: 'action', width: '10%' }
];

const expenseTabs: TabPill[] = [
  { id: ExpenseStatus.APPROVED, label: 'Approved' },
  { id: ExpenseStatus.PENDING, label: 'Pending' },
  { id: ExpenseStatus.REJECTED, label: 'Rejected' }
];

export {
  expenseTabs,
  expenseTrackerColumns,
  ExpenseTrackerConstants,
  rejectReasons
};
